import { render } from "./LoadingIndicator.vue?vue&type=template&id=e30887a6"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
